import { render, staticRenderFns } from "./AddSP.vue?vue&type=template&id=7a1baf6a&"
import script from "./AddSP.vue?vue&type=script&lang=js&"
export * from "./AddSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports